import React, { FC } from 'react';
import { Checkbox } from '@mantine/core';

export interface FilterCheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  disabled?: boolean;
}

export const CategoryCheckbox: FC<FilterCheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
}) => {
  return (
    <Checkbox
      color='#002CFB'
      size='20px'
      checked={checked}
      onChange={onChange}
      label={label}
      disabled={disabled}
      styles={{
        label: {
          fontSize: '16px',
          lineHeight: '22px',
          color: '#121922',
          cursor: 'pointer',
          maxWidth: '300px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        inner: {
          height: '22px',
          display: 'flex',
          alignItems: 'center',
        },
        input: {
          border: checked ? '2px solid #002CFB' : '2px solid rgba(173, 191, 223, 0.40)',
          cursor: 'pointer',
        },
      }}
    />
  );
};
